module.exports = "https://www.gc-pro.gnp.com.mx/11ad797b0d58903926faf31a561c59ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/localizaG.svg
// module id = 217
// module chunks = 0 1